var __jsx = React.createElement;
import React from "react";
import stl from "./BenefitsList.module.css";
var BenefitsList = function BenefitsList(_ref) {
  var title = _ref.title,
    benefits = _ref.benefits,
    image = _ref.image,
    reversed = _ref.reversed,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? "lazy" : _ref$loading;
  return /*#__PURE__*/React.createElement("div", {
    className: ["container", stl.singleBenefitContainer].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.BenefitsContainer,
    style: {
      flexDirection: reversed ? "row-reverse" : "row"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.imageCont
  }, /*#__PURE__*/React.createElement("img", {
    loading: loading,
    src: image,
    alt: "title",
    width: "50px",
    height: "50px"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.textCont
  }, /*#__PURE__*/React.createElement("h2", null, title), /*#__PURE__*/React.createElement("div", {
    className: stl.pointsCont
  }, benefits.map(function (benefit, index) {
    return /*#__PURE__*/React.createElement("p", {
      key: index
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("img", {
      src: "/assets/images/checked.svg",
      alt: "checked",
      width: "24px",
      height: "24px"
    })), benefit);
  })))));
};
export default BenefitsList;